/* Copyright (c) 2017 Backpack Health LLC */

import actionTypes from 'redux/actions';
import ProfileModel from 'models/ProfileModel';
import { types as sessionActionTypes } from 'redux/actions/session';
import userGroupRole from 'constants/userGroupRole';

const initialState = {
  isFetching: false,
  accepted: [],
  notified: [],
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case sessionActionTypes.LOG_OUT:
      return Object.assign({}, initialState);
    case actionTypes.GROUP_ADMIN_UPDATED:
      const { userId } = action;
      const accepted = state.accepted.map(a => {
        return a.user.id === userId ? _.assign({}, a, action.payload) : a;
      });
      return _.assign({}, state, { accepted });
    case actionTypes.GROUP_ADMINS_RECEIVED:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

const selectors = {
  getActive: state => state.lists.groupUsers.accepted.filter(u => u.state === 'active'),
  getPending: state => state.lists.groupUsers.notified,
  getDeactivated: state => state.lists.groupUsers.accepted.filter(u => u.state === 'inactive'),
  getActiveSorted: (state) => {
    return state.lists.groupUsers.accepted
    .filter(u => u.state === 'active')
    .sort((a, b) => {
      return ProfileModel.fullName(a.profile).localeCompare(ProfileModel.fullName(b.profile));
    })
  },
  getPendingSorted: (state) => {
    return state.lists.groupUsers.notified
      .sort((a, b) => {
        return a.group_admin.email.localeCompare(b.group_admin.email);
      });
  },
  getDeactivatedSorted: (state) => {
    return state.lists.groupUsers.accepted
    .filter(u => u.state === 'inactive')
    .sort((a, b) => {
      return ProfileModel.fullName(a.profile).localeCompare(ProfileModel.fullName(b.profile));
    })
  },
  getUser: (state, userId) => (state.lists.groupUsers.accepted.filter(u => u.user.id === userId)[0] || {}),
  isOwner: (state, userId) => (selectors.getUser(state, userId).role === userGroupRole.OWNER),
  isSoleOwnership: (state) => {
    const activeUsers = selectors.getActive(state);
    if (!activeUsers) return false;

    const activeOwners = activeUsers.filter((user) => user.role === userGroupRole.OWNER);
    return activeOwners.length === 1;
  },
};

export default selectors;
